module.exports = __webpack_public_path__ + "img/fro.037e466d.svg";